export const validateNoValue = value => {
    let error;
    if (!value) {
        error = 'Required';
    }
    return error;
}